import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { DiftWithAmount } from '@captaincause/ui/Dift'
import { Ficello } from '@captaincause/ui/Ficello'
import image1 from 'assets/home-dift-image-1.webp'
import image2 from 'assets/home-dift-image-2.webp'
import image3 from 'assets/home-dift-image-3.webp'
import image4 from 'assets/home-dift-image-4.webp'
import { Button } from 'components/Button'

export function DiftCTA() {
  const { t } = useTranslation('home.page')

  return (
    <section className="overflow-hidden bg-white">
      <div className="relative m-auto flex max-w-[1400px] flex-col items-center gap-8 px-4 py-10 md:p-20">
        <div className="absolute -top-[267px] right-[680px] hidden md:block xl:-left-[600px] xl:right-[unset]">
          <Ficello variant="raye" stroke="purple" className="rotate-[157deg]" />
          <Image
            src={image1}
            alt=""
            className="absolute left-[528px] top-[474px] h-[244px] w-[320px] rounded-[56px] object-cover"
          />
          <Image
            src={image2}
            alt=""
            className="absolute left-[663px] top-[789px] h-[200px] w-[222px] rounded-[56px] object-cover"
          />
        </div>
        <div className="absolute -top-[100px] left-[880px] hidden md:block xl:-right-[800px] xl:left-[unset]">
          <Ficello variant="looping" stroke="beige" className="" />
          <Image
            src={image3}
            alt=""
            className="absolute right-[663px] top-[355px] h-[260px] w-[320px] rounded-[56px] object-cover"
          />
          <Image
            src={image4}
            alt=""
            className="absolute right-[700px] top-[0px] h-[258px] w-[175px] rounded-[56px] object-cover"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="57"
            viewBox="0 0 46 57"
            className="absolute right-[1000px] top-[328px]"
          >
            <path
              d="M29.441 3C33.9907 9.96948 36.905 17.0847 40.702 24.2496"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M16.9058 22.1172L29.8361 36.4994"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M3 42.4625C9.21713 44.7367 19.4649 49.5222 26.2033 47.6088"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h2 className="max-w-2xl text-center font-default text-2xl font-semibold leading-8 -tracking-[1px] md:text-[40px] md:leading-[48px]">
          {t('home-diftv2-title')}
        </h2>
        <div className="relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="39"
            viewBox="0 0 39 39"
            fill="none"
            className="absolute -left-[133px] top-[63px] hidden md:block"
          >
            <path
              d="M4.62775 10.4484C10.8718 3.71065 18.8671 17.3378 20.8115 18.2473C22.756 19.1568 22.0905 0.499338 32.3778 3.41351C42.6651 6.32768 26.743 35.5638 24.481 35.7803C21.6533 36.0509 -1.61626 17.1862 4.62775 10.4484Z"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="144"
            height="68"
            viewBox="0 0 144 68"
            fill="none"
            className="absolute -left-[183px] top-[100px] hidden md:block"
          >
            <path
              d="M140.658 6.7663C104.299 30.7495 57.3118 46.3668 12.9326 45.2796"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M30.4556 27.5984C22.6 38.4418 12.5374 45.635 3.12586 45.4044"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M30.4203 64.5266C23.1209 53.312 13.4334 45.635 4.02185 45.4044"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
          </svg>
          <DiftWithAmount
            amount={{
              amount: 4000,
              currency: 'EUR',
            }}
            className="relative box-content max-h-[161px] max-w-[250px] shadow-lg"
            skipCountUp
            locale="fr"
            backgroundColor="black"
            color="white"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="147"
            height="92"
            viewBox="0 0 147 92"
            fill="none"
            className="absolute -right-[184px] top-[7px] hidden md:block"
          >
            <path
              d="M3.4549 46.6315C18.7773 34.892 38.9378 25.1769 58.7274 29.4471C71.3742 32.1761 82.5602 43.937 83.8751 56.8522C85.1169 69.0497 81.2473 81.9192 69.2056 86.8032C62.929 89.3488 56.3336 88.8137 52.3656 82.7598C46.3034 73.5109 51.7878 58.838 57.8293 51.0492C76.6834 26.7419 112.007 12.3121 142.403 17.8411"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M124.01 3.88281C128.64 6.66182 139.01 13.3314 143.455 17.7778"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M143.455 17.7734C138.825 20.5524 128.455 27.2221 124.01 31.6685"
              stroke="#B5AEFE"
              strokeWidth="6"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <p className="max-w-2xl text-center text-lg font-normal leading-8 text-dark-gray md:text-xl">
          {t('home-diftv2-description')}
        </p>
        <div className="flex flex-col gap-4 md:flex-row">
          <Button
            href="/cadeau"
            locale={false}
            className="w-[240px] rounded-[40px] px-7 py-3"
          >
            {t('home-diftv2-cta-1')}
          </Button>
          <Button
            variant="secondary"
            href="/loyalty"
            locale={false}
            className="w-[240px] rounded-[40px] px-7 py-3"
          >
            {t('home-diftv2-cta-2')}
          </Button>
        </div>
      </div>
    </section>
  )
}
